import * as React from 'react';
import {
  SearchBox
} from 'office-ui-fabric-react';
import { SearchResults } from '../common/search-results';
import { IElementDictionary } from '../../helpers';

interface IProps {
	searchTerm: string;
	showResultsWithEmptyTerm: boolean;
	labelText: string;
	results: IElementDictionary;
	awaitingResults: boolean;
	debounceDelay: number;
	isCurrentSearchComponent: boolean;
	passedSubmissionComponent: boolean;
	updateResults: (searchTerm: string, passedSubmissionComponent?: boolean) => void;
	onResultClick: (key: string, item: JSX.Element) => void;
}

export class Search extends React.Component<IProps, any> {
 
	private inputTimeout;
	private input;

	private debounce = (value: string) => {
		
		if(this.inputTimeout) {
			clearTimeout(this.inputTimeout);
		}

		this.inputTimeout = setTimeout(() => {

			this.props.updateResults(value, this.props.passedSubmissionComponent);

		}, this.props.debounceDelay);

	}

	componentDidMount () {
			setTimeout(() => {
				if(this.input) {
					this.input.focus();
				}
			}, 0);
	}

  public render() {

		let { 
			results, searchTerm, awaitingResults, isCurrentSearchComponent, onResultClick, showResultsWithEmptyTerm, labelText
		} = this.props;

		let showResults = isCurrentSearchComponent && (
			showResultsWithEmptyTerm ||
			(searchTerm && searchTerm.length)
		);

    return (
      <div>

        <SearchBox
          className="search"
          onChange={ this.debounce }
          labelText={ labelText }
          value={ isCurrentSearchComponent ? searchTerm : '' }
					ref={ search => this.input = search} />

        {
          showResults &&
            <SearchResults
              results={ results }
              awaitingResults={ awaitingResults }
              onResultClick={ onResultClick } />
        }

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./source/ts/components/search/search.tsx